import Home from '../components/home/home'
import Music from '../components/music/music'
import Channels from '../components/tv-channels/tvChannels'
import RoomControl from '../components/room-control/roomControl'
import Activities from '../components/activities/activities'
import Movies from '../components/movies/movies'
import Vod from '../components/vod/vod'
import GuestRequests from '../components/guestRequest/guestRequests'
import ViewBill from '../components/view-Bill/viewBill'
import Spa from '../components/Spa/spa'
import HCommerce from '../components/HCommerce/HCommerce'

export const routes = [
  {
    path: "/",
    component: Home
  },
  {
    path: "/music",
    component: Music
  },
  {
    path: "/activities",
    component: Activities
  },
  {
    path: "/channels",
    component: Channels
  },
  {
    path: "/RoomControl",
    component: RoomControl
  },
  {
    path: "/movies",
    component: Movies
  },
  {
    path: "/vod",
    component: Vod
  },
  {
    path: "/guestRequests",
    component: GuestRequests
  },
  {
    path: "/viewBill",
    component: ViewBill
  },
  {
    path: "/spa",
    component: Spa
  },
  {
    path: "/Hcommerce",
    component: HCommerce
  }
]